import theme from '@styles/theme';
const textAlignVariantContent = {
  start: 'left',
  center: 'center',
  end: 'right'
};
const maxWidthContentWidth = {
  small: ['100%', '100%', '70%', '50%', 450],
  medium: 723,
  large: 908
};
const getHeight = (variant: 'default' | 'other', contentWidth: 'small' | 'medium' | 'large') => {
  if (contentWidth === 'small') {
    return 'auto';
  }
  if (variant === 'other') {
    return ['auto', 'auto', '133.333333vw', '46.875vw'];
  }
  return ['138.666667vw', '138.666667vw', '133.333333vw', '46.875vw'];
};
export default {
  fullImageWithHeading: (variant: 'default' | 'other', variantContent: 'start' | 'center' | 'end', variantAlignContent: 'start' | 'center' | 'end', contentWidth: 'small' | 'medium' | 'large') => ({
    position: 'relative',
    bg: theme.rawColors.neutralWhite,
    zIndex: theme.zIndex.documentUp,
    height: getHeight(variant, contentWidth),
    display: 'flex',
    justifyContent: variantContent,
    alignItems: variantAlignContent,
    p: variant === 'other' ? ['64px 16px', '64px 16px', '64px 24px', '64px 24px', '80px 155px'] : 0
  }),
  fullImageContent: (variant: 'default' | 'other', variantContent: 'start' | 'center' | 'end', contentWidth: 'small' | 'medium' | 'large') => ({
    position: 'relative',
    color: theme.rawColors.neutralWhite,
    maxWidth: maxWidthContentWidth[contentWidth],
    width: '100%',
    textAlign: textAlignVariantContent[variantContent],
    p: variant === 'other' ? 0 : '0 40px',
    'h4.headings.heading__four': {
      pb: [16, 16, 16, 24],
      span: {
        fontSize: variant === 'other' ? theme.fontSizes.text : theme.fontSizes.h3,
        lineHeight: variant === 'other' ? '170%' : null,
        letterSpacing: variant === 'other' ? theme.letterSpacings.smallCaps : theme.letterSpacings.normal
      }
    }
  }),
  textDescription: {
    pb: [16, 16, 16, 24],
    span: {
      fontSize: theme.fontSizes.text,
      lineHeight: '175%',
      letterSpacing: theme.letterSpacings.smallCaps
    }
  }
};